export function isChecked({ date, isLetter, isWritten }) {
  if (isLetter === true && isWritten === true) {
    return 1;
  } else if (isLetter === true && isWritten === false) {
    return 2;
  } else return 0;
}
